import { useMetaByName } from '@/lib/canonical';

/**
 * <meta name="…"> без второго тега: правит тот, что уже отдал сервер
 * (или первый имеющийся), лишние убирает — как title и canonical
 * (lib/canonical.js). Вместо <Helmet><meta name="description|robots" />,
 * который дописывал второй тег рядом с серверным.
 */
export default function NativeMeta({ name, content }) {
  useMetaByName(name, content);
  return null;
}
